import React, { useEffect, useState, useRef } from 'react'
import { useNavigate } from 'react-router-dom';
import { getItem, createItem, updateItem, deleteItem } from '../../controller/Control';
import { Button, Input, DatePicker, Form, InputNumber, Select, Popconfirm, List } from 'antd';
import { IoArrowBackCircle } from "react-icons/io5";
import { PiNotePencil, PiTrashDuotone } from "react-icons/pi";
import { MdOutlineCancel } from "react-icons/md";
import Logo from '../../assets/logo.png'
import moment from 'moment';
import UploadImageWithPreview from '../FileUploader';
import './styles.css'
import jsPDF from 'jspdf';

const { TextArea } = Input;
const { Option } = Select;


interface EvolutionProps {
  userId: string;
  dataPatient: any;
  dataFirst: any;
  printDiv: () => void
}

type DateFormatProps = {
  date: string | number | Date;
};

const TimeDateFormat = ({ date }: DateFormatProps) => {
  const formattedDate = new Date(date).toLocaleString('es-ES', {
    year: 'numeric',
    month: 'long', // Mes en nombre completo (e.g. "enero", "febrero")
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false, // Formato de 24 horas
  });

  return <span>{formattedDate}</span>; // Devuelve un elemento JSX
};

const DateFormat = ({ date }: DateFormatProps) => {
	if(date !== null){
		const formattedDate = new Date(date).toLocaleString('es-ES', {
			year: 'numeric',
			month: 'long', // Mes en nombre completo (e.g. "enero", "febrero")
			day: '2-digit',
		});
  	return <span>{formattedDate}</span>; // Devuelve un elemento JSX
	}else{
		return null
	}
};



const Evolution: React.FC<EvolutionProps> = ({userId, dataPatient, dataFirst, printDiv}) => {
	const navigate = useNavigate();
	const [actionEvolution, setActionEvolution] = useState<any>({
		isView: false,
		isEdit: false,
		isAdd: false
	})
	const [evolutionData, setEvolutionData] = useState<any>([])
	const [codesData, setCodesData] = useState<any>([])
	const [evolutionSelect, setEvolutionSelect] = useState<any>({})
	const [imcValue, setImcValue] = useState<number>(0)
	const [form] = Form.useForm();
	const [item, setItem] = useState("");
	const [items, setItems] = useState<any>([]);
	const [itemFloral, setItemFloral] = useState("");
	const [itemsFloral, setItemsFloral] = useState<any>([]);
	const [itemCert, setItemCert] = useState("");
	const [itemsCert, setItemsCert] = useState<any>([]);
	const [itemDiag, setItemDiag] = useState("");
	const [itemsDiag, setItemsDiag] = useState<any>([]);
	const [isEditTreatment, setIsEditTreatment] = useState<boolean>(false)

	let formEvolution = useRef<HTMLDivElement>(null)

	const handleAdd = () => {
		if (item.trim()) {
			setItems([...items, item]);
			setItem("");
			form.setFieldsValue({ homeopatia: JSON.stringify([...items, item]) });
		}
	};

	const handleDelete = (index: number) => {
		setItems(items.filter((_: any, i: number) => i !== index));
		form.setFieldsValue({ homeopatia: JSON.stringify(items.filter((_: any, i: number) => i !== index)) });
	};

	const handleAddFloral = () => {
		if (itemFloral.trim()) {
			setItemsFloral([...itemsFloral, itemFloral]);
			setItemFloral("");
			form.setFieldsValue({ floral: JSON.stringify([...itemsFloral, itemFloral]) });
		}
	};

	const handleDeleteFloral = (index: number) => {
		setItemsFloral(itemsFloral.filter((_: any, i: number) => i !== index));
		form.setFieldsValue({ floral: JSON.stringify(itemsFloral.filter((_: any, i: number) => i !== index)) });
	};

	const handleAddDiag = () => {
		if (itemDiag.trim()) {
			setItemsDiag([...itemsDiag, itemDiag]);
			setItemDiag("");
			form.setFieldsValue({ floral: JSON.stringify([...itemsDiag, itemDiag]) });
		}
	};

	const handleDeleteDiag = (index: number) => {
		setItemsDiag(itemsDiag.filter((_: any, i: number) => i !== index));
		form.setFieldsValue({ floral: JSON.stringify(itemsDiag.filter((_: any, i: number) => i !== index)) });
	};

	const handleAddCert = () => {
		if (itemCert.trim()) {
			setItemsCert([...itemsCert, itemCert]);
			setItemCert("");
			form.setFieldsValue({ certificados: JSON.stringify([...itemsCert, itemCert]) });
		}
	};

	const handleDeleteCert = (index: number) => {
		setItemsCert(itemsCert.filter((_: any, i: number) => i !== index));
		form.setFieldsValue({ certificados: JSON.stringify(itemsCert.filter((_: any, i: number) => i !== index)) });
	};

	const getData = async() => {
		const user: any = sessionStorage.getItem('userData')
		const userJson = JSON.parse(user)
		const token = userJson.token
		const data = await getItem(`${process.env.REACT_APP_API_SERVER}/evolution/${userId}`, token)
		if(data && data.length > 0){
			setEvolutionData(data)
			getCodes()
		}else{
			setEvolutionData([])
		}
	}

	const getCodes = async() => {
		const user: any = sessionStorage.getItem('userData')
		const userJson = JSON.parse(user)
		const token = userJson.token
		const data = await getItem(`${process.env.REACT_APP_API_SERVER}/codes/`, token)
		if(data && data.length > 0){
			setCodesData(data)
		}
	}

	const goToEditTreatment = async() => {
		if(evolutionSelect && Object.keys(evolutionSelect).length > 0){
			const homeopatia = resolveJson(evolutionSelect.homeopatia)
			const floral = resolveJson(evolutionSelect.floral)
			const certificados= resolveJson(evolutionSelect.certificados)
			setItems(homeopatia)
			setItemsFloral(floral)
			setItemsCert(certificados)
		}
		setIsEditTreatment(true)
	}

	useEffect(() => {
		getData()
	}, [0])

	const resolveJson = (array: any) => {
		try {
			const parsed = JSON.parse(array);
			return parsed ?? []; // Si parsed es undefined o null, retorna un array vacío
		} catch (error) {
			return []; // Si ocurre un error en JSON.parse, retorna un array vacío
		}
	}


	const goToAddEvolution = async() => {
		const user: any = sessionStorage.getItem('userData')
		const userJson = JSON.parse(user)
		const token = userJson.token
		const values = form.getFieldsValue()
		console.log(values)
		const create: any = await createItem(`${process.env.REACT_APP_API_SERVER}/evolution`, {id_patient: userId, ...values}, token)
		if(create === 401){
			alert('Error, por favor finalice sesión e ingrese nuevamente')
		}
		if(create._id){
			form.resetFields();
			getData()
			setActionEvolution({isView: false, isEdit: false, isAdd: false})
		}
	}

	const goToEditEvolution = async() => {
		const user: any = sessionStorage.getItem('userData')
		const userJson = JSON.parse(user)
		const token = userJson.token
		const values = form.getFieldsValue()
		const data = await updateItem(`${process.env.REACT_APP_API_SERVER}/evolution/${evolutionSelect._id}`, values, token)
		if(data && Object.keys(data).length > 0){
			setEvolutionSelect(data)
			form.resetFields();
			setActionEvolution({isView: false, isAdd: false, isEdit: false})
		}
	}

	const selectEvolution = async(data: any) => {
		setItems([])
		setItemsFloral([])
		setItemsCert([])
		setEvolutionSelect(data)
	}

	const getImcValue = () => {
		const { peso, talla } = form.getFieldsValue();
		if (peso !== undefined && talla !== undefined) {
		  const imc = peso / (talla * talla);
		  const imcFormat: number = Number(imc.toFixed(2))
		  setImcValue(imcFormat);
		  form.setFieldsValue({ imc: imcFormat });
		}
	};

	const updateTreatment = async() => {
		const user: any = sessionStorage.getItem('userData')
		const userJson = JSON.parse(user)
		const token = userJson.token
		const values = {
			homeopatia: JSON.stringify(items),
			floral: JSON.stringify(itemsFloral),
			certificados: JSON.stringify(itemsCert),
			diagnostico: JSON.stringify(itemsDiag)
		}
		const data = await updateItem(`${process.env.REACT_APP_API_SERVER}/evolution/${evolutionSelect._id}`, values, token)
		if(data && Object.keys(data).length > 0){
			setEvolutionSelect(data)
			setIsEditTreatment(false)
		}
	}
  
	// Transformar los datos
	const transformedData = {
		...evolutionSelect,
		fur: evolutionSelect.fur ? moment(evolutionSelect.fur) : null,
		fecha_citologia: evolutionSelect.fecha_citologia ? moment(evolutionSelect.fecha_citologia) : null,
		fecha_laboratorio: evolutionSelect.fecha_laboratorio ? moment(evolutionSelect.fecha_laboratorio) : null
	};

	const editForm = async() => {
		setActionEvolution({isView: true, isAdd: false, isEdit: true})
		form.setFieldsValue(transformedData)
		if (formEvolution.current) {
			formEvolution.current.scrollIntoView({ behavior: 'smooth' }); // Opcional: behavior smooth para un desplazamiento suave
		} 
	}

	const deleteEvolution = async() => {
		const user: any = sessionStorage.getItem('userData')
		const userJson = JSON.parse(user)
		const token = userJson.token
		const data = await deleteItem(`${process.env.REACT_APP_API_SERVER}/evolution/${evolutionSelect._id}`, token)
		if(Object.keys(data).length > 0){
			getData()
			setEvolutionSelect({})
		}
	}

	const goToPrintHom = () => {
		const options: Intl.DateTimeFormatOptions = { year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit' };
		const createdDate = new Date(evolutionSelect.createdAt);
		const fecha = createdDate.toLocaleDateString('es-ES', options)
		const doc = new jsPDF({
			orientation: 'portrait', // Orientación vertical
			unit: 'mm',              // Unidades en milímetros
			format: 'letter',           // Formato A4
			putOnlyUsedFonts: true,  // Solo incluir fuentes usadas
			floatPrecision: 16       // Precisión de los números flotantes
		});

		const imgData = Logo
		const imgWidth = 15
		const imgHeight = 15
		const margin = 5
		const pageWidth = doc.internal.pageSize.getWidth() - margin * 2
		const pageHeight = doc.internal.pageSize.getHeight()
		const imgX = (pageWidth - imgWidth - 20);
		doc.addImage(imgData, 'JPEG', imgX, margin + 10, imgWidth, imgHeight);

	
		// Título
		const title = 'Dra. Diana Marcela Ramírez';
		const subTitle = 'Medicina General - Universidad Antonio Nariño\nMedicina Alternativa – Universidad del Rosario\nTerapias Alternativas Farmacología Vegetal – Juan N. Corpas'
		const nombreDesc = 'Nombre:'
		const nombre = dataPatient.name
		const cedulaDesc = 'C.C.:'
		const cedula = dataPatient.document
		const fechaDesc = 'Fecha'
		const nombreDescPrefixWidth = doc.getTextWidth(nombreDesc);
		const nombrePrefixWidth = doc.getTextWidth(nombre);
		const cedulaDescPrefixWidth = doc.getTextWidth(cedulaDesc);
		const fechaDescPrefixWidth = doc.getTextWidth(fechaDesc);

		const titleX = (margin + 10);
		const fontSize = 8 
		let currentY = 10
	
		doc.setFontSize(fontSize);
		doc.setTextColor(255, 0, 128);
		currentY += 10
		doc.text(title, titleX, currentY );

		doc.setFontSize(fontSize);
		doc.setTextColor(255, 0, 128);
		currentY += 5
		doc.text(subTitle, titleX, currentY);

		doc.setFontSize(fontSize);
		doc.setTextColor(255, 0, 128);
		currentY += 15
		doc.text(nombreDesc, titleX, currentY);

		doc.setFontSize(fontSize);
		doc.setTextColor(0, 0, 0);
		doc.text(nombre, titleX + nombreDescPrefixWidth, currentY);

		doc.setFontSize(fontSize);
		doc.setTextColor(255, 0, 128);
		doc.text(cedulaDesc, titleX + nombreDescPrefixWidth + nombrePrefixWidth, currentY);

		doc.setFontSize(fontSize);
		doc.setTextColor(0, 0, 0);
		doc.text(cedula, titleX + nombreDescPrefixWidth + nombrePrefixWidth + cedulaDescPrefixWidth, currentY);

		doc.setFontSize(fontSize);
		doc.setTextColor(255, 0, 128);
		currentY += 5
		doc.text(fechaDesc, titleX, currentY);

		doc.setFontSize(fontSize);
		doc.setTextColor(0, 0, 0);
		doc.text(fecha, titleX + fechaDescPrefixWidth, currentY);

		doc.setFontSize(fontSize);
		doc.setTextColor(255, 0, 128);
		currentY += 5
		doc.text('R/', titleX, currentY);

		if(evolutionSelect.homeopatia !== null){
			doc.setFontSize(fontSize);
			doc.setTextColor(0, 0, 0);
			doc.text('Tratamiento Homeopático:', titleX + 5, currentY);
			currentY += 5

			resolveJson(evolutionSelect.homeopatia).forEach((item: any) => {
				const longText = item
				const splittedText = doc.splitTextToSize(longText, pageWidth-20);
				const textHeight = doc.getTextDimensions(splittedText).h; 
				doc.text(splittedText, titleX + 7, currentY);
				currentY += textHeight + 2;
			});
			currentY += 3
		}

		doc.setFontSize(fontSize);
		doc.setTextColor(255, 0, 128);
		currentY += 105 - currentY
		doc.text('Médico:', titleX, currentY);

		doc.setFontSize(fontSize);
		doc.setTextColor(255, 0, 128);
		currentY += 10
		doc.text('_________________________________', titleX, currentY);

		doc.setFontSize(fontSize);
		doc.setTextColor(0, 0, 0);
		currentY += 4
		doc.text('Dra. Diana Marcela Ramírez González\n52516759 Bta', titleX, currentY);

		doc.setFontSize(fontSize);
		doc.setTextColor(255, 0, 128);
		currentY += 7
		doc.text('________________________________________________________________________________', titleX + 28, currentY);

		doc.setFontSize(fontSize);
		doc.setTextColor(255, 0, 128);
		currentY += 4
		doc.text('Crr 25 Nº 39 – 33 cons 301 Teléfonos: 320 - 2 72 86 02/ 3174021210  Bogotá D.C', titleX + 7, currentY);

		doc.save(`${dataPatient.document} - Homeopático.pdf`);
	}

	const goToPrintFloral = () => {
		const options: Intl.DateTimeFormatOptions = { year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit' };
		const createdDate = new Date(evolutionSelect.createdAt);
		const fecha = createdDate.toLocaleDateString('es-ES', options)
		const doc = new jsPDF({
			orientation: 'portrait', // Orientación vertical
			unit: 'mm',              // Unidades en milímetros
			format: 'letter',           // Formato A4
			putOnlyUsedFonts: true,  // Solo incluir fuentes usadas
			floatPrecision: 16       // Precisión de los números flotantes
		});

		const imgData = Logo
		const imgWidth = 15
		const imgHeight = 15
		const margin = 5
		const pageWidth = doc.internal.pageSize.getWidth() - margin * 2
		const pageHeight = doc.internal.pageSize.getHeight()
		const imgX = (pageWidth - imgWidth - 20);
		doc.addImage(imgData, 'JPEG', imgX, margin + 10, imgWidth, imgHeight);

	
		// Título
		const title = 'Dra. Diana Marcela Ramírez';
		const subTitle = 'Medicina General - Universidad Antonio Nariño\nMedicina Alternativa – Universidad del Rosario\nTerapias Alternativas Farmacología Vegetal – Juan N. Corpas'
		const nombreDesc = 'Nombre:'
		const nombre = dataPatient.name
		const cedulaDesc = 'C.C.:'
		const cedula = dataPatient.document
		const fechaDesc = 'Fecha'
		const nombreDescPrefixWidth = doc.getTextWidth(nombreDesc);
		const nombrePrefixWidth = doc.getTextWidth(nombre);
		const cedulaDescPrefixWidth = doc.getTextWidth(cedulaDesc);
		const fechaDescPrefixWidth = doc.getTextWidth(fechaDesc);

		const titleX = (margin + 10);
		const fontSize = 8 
		let currentY = 10
	
		doc.setFontSize(fontSize);
		doc.setTextColor(255, 0, 128);
		currentY += 10
		doc.text(title, titleX, currentY );

		doc.setFontSize(fontSize);
		doc.setTextColor(255, 0, 128);
		currentY += 5
		doc.text(subTitle, titleX, currentY);

		doc.setFontSize(fontSize);
		doc.setTextColor(255, 0, 128);
		currentY += 15
		doc.text(nombreDesc, titleX, currentY);

		doc.setFontSize(fontSize);
		doc.setTextColor(0, 0, 0);
		doc.text(nombre, titleX + nombreDescPrefixWidth, currentY);

		doc.setFontSize(fontSize);
		doc.setTextColor(255, 0, 128);
		doc.text(cedulaDesc, titleX + nombreDescPrefixWidth + nombrePrefixWidth, currentY);

		doc.setFontSize(fontSize);
		doc.setTextColor(0, 0, 0);
		doc.text(cedula, titleX + nombreDescPrefixWidth + nombrePrefixWidth + cedulaDescPrefixWidth, currentY);

		doc.setFontSize(fontSize);
		doc.setTextColor(255, 0, 128);
		currentY += 5
		doc.text(fechaDesc, titleX, currentY);

		doc.setFontSize(fontSize);
		doc.setTextColor(0, 0, 0);
		doc.text(fecha, titleX + fechaDescPrefixWidth, currentY);

		doc.setFontSize(fontSize);
		doc.setTextColor(255, 0, 128);
		currentY += 5
		doc.text('R/', titleX, currentY);


		if(evolutionSelect.floral !== null){
			doc.setFontSize(fontSize);
			doc.setTextColor(0, 0, 0);
			doc.text('Tratamiento Esencia Floral:', titleX + 5, currentY);
			currentY += 5

			resolveJson(evolutionSelect.floral).forEach((item: any) => {
				const longText = item
				const splittedText = doc.splitTextToSize(longText, pageWidth-20);
				const textHeight = doc.getTextDimensions(splittedText).h; 
				doc.text(splittedText, titleX + 7, currentY);
				currentY += textHeight + 2;
			});
			currentY += 3
		}
		doc.setFontSize(fontSize);
		doc.setTextColor(255, 0, 128);
		currentY += 105 - currentY
		doc.text('Médico:', titleX, currentY);

		doc.setFontSize(fontSize);
		doc.setTextColor(255, 0, 128);
		currentY += 10
		doc.text('_________________________________', titleX, currentY);

		doc.setFontSize(fontSize);
		doc.setTextColor(0, 0, 0);
		currentY += 4
		doc.text('Dra. Diana Marcela Ramírez González\n52516759 Bta', titleX, currentY);

		doc.setFontSize(fontSize);
		doc.setTextColor(255, 0, 128);
		currentY += 7
		doc.text('________________________________________________________________________________', titleX + 28, currentY);

		doc.setFontSize(fontSize);
		doc.setTextColor(255, 0, 128);
		currentY += 4
		doc.text('Crr 25 Nº 39 – 33 cons 301 Teléfonos: 320 - 2 72 86 02/ 3174021210  Bogotá D.C', titleX + 7, currentY);

		doc.save(`${dataPatient.document} - Esencia Floral.pdf`);
	}

	const goToPrintCert = () => {
		const options: Intl.DateTimeFormatOptions = { year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit' };
		const createdDate = new Date(evolutionSelect.createdAt);
		const fecha = createdDate.toLocaleDateString('es-ES', options)
		const doc = new jsPDF({
			orientation: 'portrait', // Orientación vertical
			unit: 'mm',              // Unidades en milímetros
			format: 'letter',           // Formato A4
			putOnlyUsedFonts: true,  // Solo incluir fuentes usadas
			floatPrecision: 16       // Precisión de los números flotantes
		});

		const imgData = Logo
		const imgWidth = 15
		const imgHeight = 15
		const margin = 5
		const pageWidth = doc.internal.pageSize.getWidth() - margin * 2
		const pageHeight = doc.internal.pageSize.getHeight()
		const imgX = (pageWidth - imgWidth - 20);
		doc.addImage(imgData, 'JPEG', imgX, margin + 10, imgWidth, imgHeight);

	
		// Título
		const title = 'Dra. Diana Marcela Ramírez';
		const subTitle = 'Medicina General - Universidad Antonio Nariño\nMedicina Alternativa – Universidad del Rosario\nTerapias Alternativas Farmacología Vegetal – Juan N. Corpas'
		const nombreDesc = 'Nombre:'
		const nombre = dataPatient.name
		const cedulaDesc = 'C.C.:'
		const cedula = dataPatient.document
		const fechaDesc = 'Fecha'
		const nombreDescPrefixWidth = doc.getTextWidth(nombreDesc);
		const nombrePrefixWidth = doc.getTextWidth(nombre);
		const cedulaDescPrefixWidth = doc.getTextWidth(cedulaDesc);
		const fechaDescPrefixWidth = doc.getTextWidth(fechaDesc);

		const titleX = (margin + 10);
		const fontSize = 8 
		let currentY = 10
	
		doc.setFontSize(fontSize);
		doc.setTextColor(255, 0, 128);
		currentY += 10
		doc.text(title, titleX, currentY );

		doc.setFontSize(fontSize);
		doc.setTextColor(255, 0, 128);
		currentY += 5
		doc.text(subTitle, titleX, currentY);

		doc.setFontSize(fontSize);
		doc.setTextColor(255, 0, 128);
		currentY += 15
		doc.text(nombreDesc, titleX, currentY);

		doc.setFontSize(fontSize);
		doc.setTextColor(0, 0, 0);
		doc.text(nombre, titleX + nombreDescPrefixWidth, currentY);

		doc.setFontSize(fontSize);
		doc.setTextColor(255, 0, 128);
		doc.text(cedulaDesc, titleX + nombreDescPrefixWidth + nombrePrefixWidth, currentY);

		doc.setFontSize(fontSize);
		doc.setTextColor(0, 0, 0);
		doc.text(cedula, titleX + nombreDescPrefixWidth + nombrePrefixWidth + cedulaDescPrefixWidth, currentY);

		doc.setFontSize(fontSize);
		doc.setTextColor(255, 0, 128);
		currentY += 5
		doc.text(fechaDesc, titleX, currentY);

		doc.setFontSize(fontSize);
		doc.setTextColor(0, 0, 0);
		doc.text(fecha, titleX + fechaDescPrefixWidth, currentY);

		doc.setFontSize(fontSize);
		doc.setTextColor(255, 0, 128);
		currentY += 5
		doc.text('R/', titleX, currentY);


		if(evolutionSelect.certificados !== null){
			doc.setFontSize(fontSize);
			doc.setTextColor(0, 0, 0);
			doc.text('Certificados:', titleX + 5, currentY);
			currentY += 5

			resolveJson(evolutionSelect.certificados).forEach((item: any) => {
				const longText = item
				const splittedText = doc.splitTextToSize(longText, pageWidth-20);
				const textHeight = doc.getTextDimensions(splittedText).h; 
				doc.text(splittedText, titleX + 7, currentY);
				currentY += textHeight + 2;
			});
			currentY += 3
		}
		doc.setFontSize(fontSize);
		doc.setTextColor(255, 0, 128);
		currentY += 105 - currentY
		doc.text('Médico:', titleX, currentY);

		doc.setFontSize(fontSize);
		doc.setTextColor(255, 0, 128);
		currentY += 10
		doc.text('_________________________________', titleX, currentY);

		doc.setFontSize(fontSize);
		doc.setTextColor(0, 0, 0);
		currentY += 4
		doc.text('Dra. Diana Marcela Ramírez González\n52516759 Bta', titleX, currentY);

		doc.setFontSize(fontSize);
		doc.setTextColor(255, 0, 128);
		currentY += 7
		doc.text('________________________________________________________________________________', titleX + 28, currentY);

		doc.setFontSize(fontSize);
		doc.setTextColor(255, 0, 128);
		currentY += 4
		doc.text('Crr 25 Nº 39 – 33 cons 301 Teléfonos: 320 - 2 72 86 02/ 3174021210  Bogotá D.C', titleX + 7, currentY);

		doc.save(`${dataPatient.document} - Certificado.pdf`);
	}
	
	
	return(
		<div>
			<div ref={formEvolution}>
				<button className='bg-red-600 text-white p-1.5 rounded-md hover:bg-red-700 text-sm my-3 lg:mx-2 ocultarPrintDiv' type="button" onClick={() => setActionEvolution({isView: true, isAdd: true, isEdit: false})}>
					Agregar Evolución de Paciente
				</button>
			</div>
			<div className='justify-start flex-col items-center evolution' style={actionEvolution.isView ? {display: 'flex'} : {display: 'none'}}>
				<h1 className='text-2xl text-text-menu my-5'>{actionEvolution.isAdd ? 'Agregar Evolución Paciente' : 'Modificar Evolución Paciente'}</h1>
				<Form
					layout="vertical"
					form={form}
					style={{width: '100%'}}
				>
					<div className='flex flex-row justify-around items-start flex-wrap'>
						<div className='w-96 m-5 border-[1px] border-slate-400 p-5 rounded-lg'>
							<h3 className='text-xl text-text-menu my-5'>Sección Inicial</h3>
							<Form.Item label="Motivo" name="reason">
								<TextArea />
							</Form.Item>

							<Form.Item label="Duración del Dolor (Tiempo)" name="time">
								<Input />
							</Form.Item>

							<Form.Item label="Historial" name="history">
								<TextArea />
							</Form.Item>

							<Form.Item label="Localización" name="localization">
								<Input />
							</Form.Item>

							<Form.Item label="Dolor (Sí/No)" name="pain">
								<Select>
									<Option value="sí">Sí</Option>
									<Option value="no">No</Option>
								</Select>
							</Form.Item>

							<Form.Item label="Número de Dolor" name="pain_number">
								<Input style={{width: '80px'}} />
							</Form.Item>

							<Form.Item label="Alivio" name="get_relief">
								<Input />
							</Form.Item>

							<Form.Item label="Empeoramiento" name="get_worsen">
								<Input />
							</Form.Item>

							<Form.Item label="Dolor Continuo (Sí/No)" name="continuous">
								<Select>
									<Option value="sí">Sí</Option>
									<Option value="no">No</Option>
								</Select>
							</Form.Item>

							<Form.Item label="Signos" name="signs">
								<TextArea />
							</Form.Item>

							<Form.Item label="Tratamientos" name="treatments">
								<TextArea />
							</Form.Item>

							<Form.Item label="Hospitalizaciones" name="hospitable">
								<TextArea />
							</Form.Item>

							<Form.Item label="Eventos Traumáticos" name="traumatic">
								<TextArea />
							</Form.Item>

							<Form.Item label="Tratamiento Farmacológico" name="pharmacologic">
								<TextArea />
							</Form.Item>
						</div>
						<div className='w-96 m-5 border-[1px] border-slate-400 p-5 rounded-lg'>
							<h3 className='text-xl text-text-menu my-5'>Sección Ginecológica</h3>

							<Form.Item label="Menarquia" name="menarquia">
								<Input />
							</Form.Item>

							<Form.Item label="FUR (Fecha Última Regla)" name="fur">
								<DatePicker />
							</Form.Item>

							<Form.Item label="Ciclos Menstruales" name="ciclos_regla">
								<Input />
							</Form.Item>
							<div className='flex flex-row flex-wrap justify-around'>
								<Form.Item label="G (Gravidez)" name="g">
									<Input style={{width: '80px'}} />
								</Form.Item>

								<Form.Item label="P (Partos)" name="p">
									<Input style={{width: '80px'}} />
								</Form.Item>

								<Form.Item label="C (Cesáreas)" name="c">
									<Input style={{width: '80px'}} />
								</Form.Item>

								<Form.Item label="A (Abortos)" name="a">
									<Input style={{width: '80px'}} />
								</Form.Item>

								<Form.Item label="E (Ectopicos)" name="e">
									<Input style={{width: '80px'}} />
								</Form.Item>

								<Form.Item label="M (Mortinatos)" name="m">
									<Input style={{width: '80px'}} />
								</Form.Item>

								<Form.Item label="V (Vivos)" name="v">
									<Input style={{width: '80px'}} />
								</Form.Item>
							</div>
							<Form.Item label="UCV" name="ucv">
								<Input />
							</Form.Item>

							<Form.Item label="Fecha de Citología" name="fecha_citologia">
								<DatePicker style={{ width: '100%' }} />
							</Form.Item>

							<Form.Item label="Método Anticonceptivo (PF)" name="pf">
								<Input />
							</Form.Item>

							<Form.Item label="Menopausia" name="menopausia">
								<Select>
									<Option value="sí">Sí</Option>
									<Option value="no">No</Option>
								</Select>
							</Form.Item>
						</div>
						<div className='w-96 m-5 border-[1px] border-slate-400 p-5 rounded-lg'>
							<h3 className='text-xl text-text-menu my-5'>Sección Tres</h3>

							<Form.Item label="Generalidades" name="generalidades">
								<TextArea />
							</Form.Item>

							<Form.Item label="Digestivo" name="digestivo">
								<TextArea />
							</Form.Item>

							<Form.Item label="Genitourinario" name="genitourinario">
								<TextArea />
							</Form.Item>

							<Form.Item label="Sueño" name="sueño">
								<TextArea />
							</Form.Item>

							<Form.Item label="Alimentación" name="alimentacion">
								<TextArea />
							</Form.Item>

							<Form.Item label="Temperamento" name="temperamento">
								<TextArea />
							</Form.Item>
						</div>
						<div className='w-96 m-5 border-[1px] border-slate-400 p-5 rounded-lg'>
							<h3 className='text-xl text-text-menu my-5'>Laboratorios</h3>
							<Form.Item label="Fecha de Laboratorio" name="fecha_laboratorio">
								<DatePicker />
							</Form.Item>
							<div className='flex flex-row flex-wrap justify-around'>
								<Form.Item label="Glicemia" name="glicemia">
									<Input style={{width: '80px'}} />
								</Form.Item>

								<Form.Item label="HB Glicosilada" name="hb_glicosilada">
									<Input style={{width: '80px'}} />
								</Form.Item>

								<Form.Item label="TSH" name="tsh">
									<Input style={{width: '80px'}} />
								</Form.Item>

								<Form.Item label="Creatinina" name="creatinina">
									<Input style={{width: '80px'}} />
								</Form.Item>

								<Form.Item label="BUN" name="bun">
									<Input style={{width: '80px'}} />
								</Form.Item>

								<Form.Item label="HB" name="hb">
									<Input style={{width: '80px'}} />
								</Form.Item>

								<Form.Item label="HTO" name="hto">
									<Input style={{width: '80px'}} />
								</Form.Item>

								<Form.Item label="Plaquetas" name="plaq">
									<Input style={{width: '80px'}} />
								</Form.Item>

								<Form.Item label="Linfocitos" name="linfos">
									<Input style={{width: '80px'}} />
								</Form.Item>

								<Form.Item label="Eosinófilos" name="eos">
									<Input style={{width: '80px'}} />
								</Form.Item>

								<Form.Item label="Neutrófilos" name="neutro">
									<Input style={{width: '80px'}} />
								</Form.Item>

								<Form.Item label="TGO" name="tgo">
									<Input style={{width: '80px'}} />
								</Form.Item>

								<Form.Item label="TGP" name="tgp">
									<Input style={{width: '80px'}} />
								</Form.Item>

								<Form.Item label="HDL" name="hdl">
									<Input style={{width: '80px'}} />
								</Form.Item>

								<Form.Item label="LDL" name="ldl">
									<Input style={{width: '80px'}} />
								</Form.Item>

								<Form.Item label="Colesterol" name="colesterol">
									<Input style={{width: '80px'}} />
								</Form.Item>

								<Form.Item label="Triglicéridos" name="trigliceridos">
									<Input style={{width: '80px'}} />
								</Form.Item>

								<Form.Item label="Ácido Úrico" name="urico">
									<Input style={{width: '80px'}} />
								</Form.Item>
							</div>
							<Form.Item label="Orina" name="orina">
								<TextArea />
							</Form.Item>

							<Form.Item label="Otros" name="otros">
								<TextArea />
							</Form.Item>
						</div>
						<div className='w-96 m-5 border-[1px] border-slate-400 p-5 rounded-lg'>
							<h3 className='text-xl text-text-menu my-5'>Examen Físico</h3>
							<h3>Signos Vitales</h3>
							<div className='flex flex-row flex-wrap justify-around'>
								<Form.Item label="Frecuencia Cardiaca (FC)" name="fc">
									<Input style={{width: '80px'}} />
								</Form.Item>

								<Form.Item label="Frecuencia Respiratoria (FR)" name="fr">
									<Input style={{width: '80px'}} />
								</Form.Item>

								<Form.Item label="Presión Arterial (TA)" name="ta">
									<Input style={{width: '80px'}} />
								</Form.Item>

								<Form.Item label="Talla" name="talla">
									<Input style={{width: '80px'}} />
								</Form.Item>

								<Form.Item label="Peso" name="peso">
									<Input style={{width: '80px'}} />
								</Form.Item>

								<Form.Item label="Grasa Corporal" name="grasa_corporal">
									<Input style={{width: '80px'}} />
								</Form.Item>

								<Form.Item label="Grasa Visceral" name="grasa_visceral">
									<Input style={{width: '80px'}} />
								</Form.Item>

								<Form.Item label="IMC" name="imc">
									<InputNumber value={imcValue} readOnly onClick={getImcValue}/>
								</Form.Item>

								<Form.Item label="Músculo" name="musculo">
									<Input style={{width: '80px'}} />
								</Form.Item>
							</div>
							<Form.Item label="Generalidades" name="generalidades_sistema">
								<Input />
							</Form.Item>
						</div>
						<div className='w-96 m-5 border-[1px] border-slate-400 p-5 rounded-lg'>
							<h3 className='text-xl text-text-menu my-5'>Plan de Manejo</h3>

							<Form.Item label="Análisis" name="analisis">
								<TextArea />
							</Form.Item>

							<Form.Item label="Diagnóstico" name="diagnostico">
								<TextArea readOnly disabled/>
							</Form.Item>

							<Form.Item label="Acupuntura" name="acupuntura">
								<Select>
									<Option value="sí">Sí</Option>
									<Option value="no">No</Option>
								</Select>
							</Form.Item>

							<Form.Item label="Técnica de Acupuntura" name="acupuntura_tecnica">
								<TextArea />
							</Form.Item>

							<Form.Item label="Terapia Neural" name="neural">
								<Select>
									<Option value="sí">Sí</Option>
									<Option value="no">No</Option>
								</Select>
							</Form.Item>

							<Form.Item label="Técnica Neural" name="neural_tecnica">
								<TextArea />
							</Form.Item>

							<Form.Item label="Armonización" name="armonizacion">
								<Select>
									<Option value="sí">Sí</Option>
									<Option value="no">No</Option>
								</Select>
							</Form.Item>

							<Form.Item label="Técnica Armonización" name="armonizacion_tecnica">
								<TextArea />
							</Form.Item>

							<Form.Item label="Homeopatía" name="homeopatia">
								<TextArea readOnly disabled/>
							</Form.Item>

							<Form.Item label="Esencia Floral" name="floral">
								<TextArea readOnly disabled/>
							</Form.Item>

							<Form.Item label="Certificados" name="certificados">
								<TextArea readOnly disabled/>
							</Form.Item>
						</div>
					</div>

					{/* Botón de Enviar */}
					<Form.Item className='text-center'>
						{actionEvolution.isEdit ?
							<Popconfirm 
								title="Seguro quiere modificar estos datos?"
								description="Esta acción no se puede deshacer"
								cancelText="Cancelar"
								onConfirm={goToEditEvolution}
							>
								<button className='bg-buttons text-white p-1.5 rounded-md hover:bg-hover-buttons text-sm' type="submit">
									Modificar
								</button>
							</Popconfirm> :
							<button className='bg-buttons text-white p-1.5 rounded-md hover:bg-hover-buttons text-sm' type="submit" onClick={goToAddEvolution}>
								Agregar
							</button>
						}
						<button className='bg-red-600 text-white p-1.5 rounded-md hover:bg-red-700 text-sm mx-2' type="button" onClick={() => setActionEvolution({isView: false, isAdd: false, isEdit: false})}>
							Cancelar
						</button>
					</Form.Item>
				</Form>
			</div>
			<div className='flex'>
				<div className='p-5 border-0 rounded-md border-text-menu lg:w-1/4 w-full lg:mx-2 relative ocultarPrintDiv'>
					<h1 className='text-text-menu' style={{fontSize: '2em'}}>Evoluciones</h1>
					<div className='max-h-[500px] overflow-y-scroll custom-scrollbar text-center flex flex-col items-center'>
						{evolutionData.map((x: any, i: number) => {return(
							<div key={i} className='border-2 border-holistic bg-rose-200 my-3 p-3 rounded-xl shadow-lg hover:scale-105 cursor-pointer max-w-[90%]' onClick={() => selectEvolution(x)}>
								<p className='text-text-menu'>{new Date(x.createdAt).toLocaleString('es-ES', {
										year: 'numeric',
										month: 'long',
										day: '2-digit',
										hour: '2-digit',
										minute: '2-digit',
										second: '2-digit',
										hour12: true, // Usa formato de 24 horas
									})}
								</p>
							</div>
						)})}
					</div>
				</div>
				{Object.keys(evolutionSelect).length === 0 ? null :
				<div className='w-[90%] my-5'>
					<div className='w-full text-center text-text-menu text-[1.5em]'>{<TimeDateFormat date={evolutionSelect.createdAt}/>}</div>
					<div className='mt-5'>
						<p><strong>Motivo de Consulta: </strong>{evolutionSelect.reason}</p>
					</div>
					<div className='flex justify-start mt-5 flex-wrap'>
						<div className='flex-grow mx-3 max-w-[400px] my-3'>
							<h1 className='text-text-menu' style={{fontSize: '1.2em'}}>Enfermedad Actual</h1>
							<div>
								<p><strong>Tiempo: </strong>{evolutionSelect.time}</p>
								<p><strong>Historia: </strong>{evolutionSelect.history}</p>
								<p><strong>Localización: </strong>{evolutionSelect.localization}</p>
								<p><strong>Dolor: </strong>{evolutionSelect.pain}</p>
								<p><strong>Escala Dolor: </strong>{evolutionSelect.pain_number}</p>
								<p><strong>Con que Mejora: </strong>{evolutionSelect.get_relief}</p>
								<p><strong>Con que Empeora: </strong>{evolutionSelect.get_worsen}</p>
								<p><strong>Continuo: </strong>{evolutionSelect.continuous}</p>
								<p><strong>Signos y Sintomas: </strong>{evolutionSelect.signs}</p>
								<p><strong>Tratamientos: </strong>{evolutionSelect.treatments}</p>
							</div>
						</div>

						<div className='flex-grow mx-3 max-w-[400px] my-3'>
							<h1 className='text-text-menu' style={{fontSize: '1.2em'}}>Hospitalizaciones y Traumas</h1>
							<div>
								<p><strong>Hospitalarios: </strong>{evolutionSelect.hospitable}</p>
								<p><strong>Traumáticos: </strong>{evolutionSelect.traumatic}</p>
								<p><strong>Farmacológicos: </strong>{evolutionSelect.pharmacologic}</p>
							</div>
						</div>

						<div className='flex-grow mx-3 max-w-[400px] my-3'>
							<h1 className='text-text-menu' style={{fontSize: '1.2em'}}>Ginecológico</h1>
							<div>
								<p><strong>Menarquia: </strong>{evolutionSelect.menarquia}</p>
								<p>
									<strong>FUR: </strong>{<DateFormat date={evolutionSelect.fur} />}
								</p>
								<p><strong>Ciclos: </strong>{evolutionSelect.ciclos_regla}</p>
								<p>
									<strong>G: </strong>{evolutionSelect.g}
									<strong className='ml-2'>P: </strong>{evolutionSelect.p}
									<strong className='ml-2'>C: </strong>{evolutionSelect.c}
									<strong className='ml-2'>A: </strong>{evolutionSelect.a}
									<strong className='ml-2'>E: </strong>{evolutionSelect.e}
									<strong className='ml-2'>M: </strong>{evolutionSelect.m}
									<strong className='ml-2'>V: </strong>{evolutionSelect.v}
								</p>
								<p>
									<strong>UCV: </strong>{evolutionSelect.ucv} 
									<strong className='ml-2'>Ultima Citologia: </strong>{<DateFormat date={evolutionSelect.fecha_citologia} />}
								</p>
								<p><strong>PF: </strong>{evolutionSelect.pf}</p>
								<p><strong>Menopausia: </strong>{evolutionSelect.menopausia}</p>
							</div>
						</div>
						<div className='flex-grow mx-3 max-w-[400px] my-3'>
							<h1 className='text-text-menu' style={{fontSize: '1.2em'}}>Revisión por Sistemas</h1>
							<div>
								<p><strong>S. Digestivo: </strong>{evolutionSelect.digestivo}</p>
								<p><strong>S. Genitourinario: </strong>{evolutionSelect.genitourinario}</p>
								<p><strong>Sueño: </strong>{evolutionSelect.sueno}</p>
								<p><strong>Alimentación: </strong>{evolutionSelect.alimentacion}</p>
								<p><strong>Temperamento: </strong>{evolutionSelect.temperamento}</p>
							</div>
						</div>
						<div className='flex-grow mx-3 max-w-[400px] my-3'>
							<h1 className='text-text-menu' style={{fontSize: '1.2em'}}>Laboratorios</h1>
							<div>
								<p>
									<strong>Fecha: </strong>{<DateFormat date={evolutionSelect.fecha_laboratorio} />}
									<strong className='ml-2'>Glicemia: </strong>{evolutionSelect.glicemia}
									<strong className='ml-2'>HB Glicosilada: </strong>{evolutionSelect.hb_glicosilada}
								</p>
								<p>
									<strong>TSH: </strong>{evolutionSelect.tsh}
									<strong className='ml-2'>Creatinina: </strong>{evolutionSelect.creatinina}
									<strong className='ml-2'>BUN: </strong>{evolutionSelect.bun}
								</p>
								<p>
									<strong>HB: </strong>{evolutionSelect.hb}
									<strong className='ml-2'>HTO: </strong>{evolutionSelect.hto}
									<strong className='ml-2'>Plaq: </strong>{evolutionSelect.plaq}
									<strong className='ml-2'>Linfos: </strong>{evolutionSelect.linfos}
									<strong className='ml-2'>Eos: </strong>{evolutionSelect.eos}
									<strong className='ml-2'>Neutro: </strong>{evolutionSelect.neutro}
								</p>
								<p>
									<strong>TGO: </strong>{evolutionSelect.tgo}
									<strong className='ml-2'>TGP: </strong>{evolutionSelect.tgp}
								</p>
								<h1 className='text-slate-900' style={{fontSize: '1.1em'}}>Perfil Lipidico</h1>
								<p>
									<strong>HDL: </strong>{evolutionSelect.hdl}
									<strong className='ml-2'>LDL: </strong>{evolutionSelect.ldl}
									<strong className='ml-2'>Colesterol Total: </strong>{evolutionSelect.colesterol}
								</p>
								<p>
									<strong>Trigliceridos: </strong>{evolutionSelect.trigliceridos}
									<strong className='ml-2'>Acido Urico: </strong>{evolutionSelect.urico}
									<strong className='ml-2'>Parcial de Orina: </strong>{evolutionSelect.orina}
								</p>
								<p><strong>Otros: </strong>{evolutionSelect.otros}</p>
							</div>
						</div>
						<div className='flex-grow mx-3 max-w-[400px] my-3'>
							<h1 className='text-text-menu' style={{fontSize: '1.2em'}}>Examen Fisico</h1>
							<div>
								<h1 className='text-slate-900' style={{fontSize: '1.1em'}}>Signos Vitales</h1>
								<p>
									<strong>FC: </strong>{evolutionSelect.fc}X`
									<strong className='ml-2'>FR: </strong>{evolutionSelect.fr}X`
									<strong className='ml-2'>TA: </strong>{evolutionSelect.ta}mmHg
									<strong className='ml-2'>Talla: </strong>{evolutionSelect.talla}cm
								</p>
								<p><strong>Peso: </strong>{evolutionSelect.peso}</p>
								<p><strong>% Grasa Corporal: </strong>{evolutionSelect.grasa_corporal}</p>
								<p><strong>% Grasa Visceral: </strong>{evolutionSelect.grasa_visceral}</p>
								<p><strong>IMC: </strong>{evolutionSelect.imc}</p>
								<p><strong>% de Musculo: </strong>{evolutionSelect.musculo}</p>
								<p><strong>Generalidades: </strong>{evolutionSelect.generalidades}</p>
							</div>
						</div>
					</div>
					<hr />
					<div className='flex justify-start mt-5 flex-wrap flex-row'>
						<div className='flex-grow mx-3 my-3'>
							<h1 className='text-text-menu' style={{fontSize: '1.2em'}}>Plan de Manejo</h1>
							<p><strong>Analisis: </strong>{evolutionSelect.analisis}</p>
							<h1 className='text-slate-900' style={{fontSize: '1.1em'}}>Plan Terapeutico</h1>
							<p><strong>Acupuntura: </strong>{evolutionSelect.acupuntura}</p>
							<p><strong>Técnica: </strong>{evolutionSelect.acupuntura_tecnica}</p>
							<p><strong>Terapia Neural: </strong>{evolutionSelect.neural}</p>
							<p><strong>Técnica: </strong>{evolutionSelect.neural_tecnica}</p>
							<p><strong>Armonización: </strong>{evolutionSelect.armonizacion}</p>
							<p><strong>Técnica: </strong>{evolutionSelect.armonizacion_tecnica}</p>
						</div>
						<div className='flex-grow mx-3 my-3'>
						<div style={{ maxWidth: 400, margin: "20px auto" }}>
							<h2 className='text-text-menu my-2 text-lg'>Diagnóstico</h2>
							{!isEditTreatment ?
								<ul className='list-disc'>
								{Object.keys(evolutionSelect).length > 0 && evolutionSelect.diagnostico !== undefined ? resolveJson(evolutionSelect.diagnostico).map((x: string, i: number) => {
									return(
										<li key={i}>{x}</li>
									)
								}) : null}
								</ul>
							: <>
								{/* <Input
									placeholder="Agregar un elemento"
									value={itemDiag}
									onChange={(e) => setItemDiag(e.target.value)}
									onPressEnter={handleAddDiag} // Permite agregar con Enter
									style={{ marginBottom: 10 }}
								/> */}
								<Select 
									className='w-full mb-3' 
									placeholder="Filtrar por Paciente"
									value={itemDiag}
									showSearch
									filterOption={(input, option: any) => 
										option?.children && typeof option.children === 'string' 
											? option.children.toLowerCase().includes(input.toLowerCase()) 
											: false // Asegúrate de que `children` no sea undefined
									} 
									onChange={(value) => setItemDiag(value)} // Actualizar id_user con el valor seleccionado
								>
									{codesData.map((data: any) => (
										<Select.Option value={`${data.code} - ${data.description}`} key={data._id}>{`${data.code} - ${data.description}`}</Select.Option> // Usar el _id como value y name como texto visible
									))}
								</Select>
								<Button onClick={handleAddDiag} block style={{backgroundColor: '#B0BEC5', color: '#fff'}}>
									Agregar
								</Button>

								<List
									bordered
									dataSource={itemsDiag}
									renderItem={(itemDiag: any, index: number) => (
									<List.Item
										actions={[
										<Button type="link" danger onClick={() => handleDeleteDiag(index)}>
											Eliminar
										</Button>,
										]}
									>
										{itemDiag}
									</List.Item>
									)}
									style={{ marginTop: 20 }}
								/>
							</>}
						</div>
						</div>
						<div className='flex-grow-0 flex items-end'>
							<PiNotePencil size={35} color='#B71C1C' style={{cursor: 'pointer'}} onClick={editForm}/>
							<Popconfirm 
									title="Seguro quiere borrar la evolución?"
									description="Esta acción no se puede deshacer"
									cancelText="Cancelar"
									onConfirm={deleteEvolution}
								>
								<PiTrashDuotone  size={35} color='red' style={{cursor: 'pointer'}}/>
							</Popconfirm>
						</div>
					</div>
					<hr />
					<div className='flex justify-center my-5'><h1 className='text-text-menu' style={{fontSize: '1.2em'}}>Tratamientos</h1></div>
					<div className='flex justify-between flex-wrap'>
						<div style={{ maxWidth: 400, margin: "20px auto" }}>
							<h2 className='text-text-menu my-2 text-lg'>Tratamiento homeopático</h2>
							{!isEditTreatment ?
								<ul className='list-disc'>
								{Object.keys(evolutionSelect).length > 0 && evolutionSelect.homeopatia !== undefined ? resolveJson(evolutionSelect.homeopatia).map((x: string, i: number) => {
									return(
										<li key={i}>{x}</li>
									)
								}) : null}
								</ul>
							: <>
								<Input
									placeholder="Agregar un elemento"
									value={item}
									onChange={(e) => setItem(e.target.value)}
									onPressEnter={handleAdd} // Permite agregar con Enter
									style={{ marginBottom: 10 }}
								/>
								<Button onClick={handleAdd} block style={{backgroundColor: '#B0BEC5', color: '#fff'}}>
									Agregar
								</Button>

								<List
									bordered
									dataSource={items}
									renderItem={(item: any, index: number) => (
									<List.Item
										actions={[
										<Button type="link" danger onClick={() => handleDelete(index)}>
											Eliminar
										</Button>,
										]}
									>
										{item}
									</List.Item>
									)}
									style={{ marginTop: 20 }}
								/>
							</>}
						</div>
						<div style={{ maxWidth: 400, margin: "20px auto" }}>
							<h2 className='text-text-menu my-2 text-lg'>Tratamiento Esencia Floral</h2>
							{!isEditTreatment ?
								<ul className='list-disc'>
								{Object.keys(evolutionSelect).length > 0 && evolutionSelect.floral !== undefined ? resolveJson(evolutionSelect.floral).map((x: string, i: number) => {
									return(
										<li key={i}>{x}</li>
									)
								}) : null}
								</ul>
							: <>
								<Input
									placeholder="Agregar un elemento"
									value={itemFloral}
									onChange={(e) => setItemFloral(e.target.value)}
									onPressEnter={handleAddFloral} // Permite agregar con Enter
									style={{ marginBottom: 10 }}
								/>
								<Button onClick={handleAddFloral} block style={{backgroundColor: '#B0BEC5', color: '#fff'}}>
									Agregar
								</Button>

								<List
									bordered
									dataSource={itemsFloral}
									renderItem={(itemFloral: any, index: number) => (
									<List.Item
										actions={[
										<Button type="link" danger onClick={() => handleDeleteFloral(index)}>
											Eliminar
										</Button>,
										]}
									>
										{itemFloral}
									</List.Item>
									)}
									style={{ marginTop: 20 }}
								/>
							</>}
						</div>
						<div style={{ maxWidth: 400, margin: "20px auto" }}>
							<h2 className='text-text-menu my-2 text-lg'>Solicitar un Certificado</h2>
							{!isEditTreatment ?
								<ul className='list-disc'>
								{Object.keys(evolutionSelect).length > 0 && evolutionSelect.certificados !== undefined ? resolveJson(evolutionSelect.certificados).map((x: string, i: number) => {
									return(
										<li key={i}>{x}</li>
									)
								}) : null}
								</ul>
							: <>
								<Input
									placeholder="Agregar un elemento"
									value={itemCert}
									onChange={(e) => setItemCert(e.target.value)}
									onPressEnter={handleAddCert} // Permite agregar con Enter
									style={{ marginBottom: 10 }}
								/>
								<Button onClick={handleAddCert} block style={{backgroundColor: '#B0BEC5', color: '#fff'}}>
									Agregar
								</Button>

								<List
									bordered
									dataSource={itemsCert}
									renderItem={(itemCert: any, index: number) => (
									<List.Item
										actions={[
										<Button type="link" danger onClick={() => handleDeleteCert(index)}>
											Eliminar
										</Button>,
										]}
									>
										{itemCert}
									</List.Item>
									)}
									style={{ marginTop: 20 }}
								/>
							</>}
						</div>
					</div>
					<div className='flex justify-center ocultarPrintDiv'>
						{isEditTreatment ?
							<>
								<Popconfirm 
									title="Seguro quiere modificar estos datos?"
									description="Esta acción no se puede deshacer"
									cancelText="Cancelar"
									onConfirm={updateTreatment}
								>
									<button className='bg-red-500 text-white p-1.5 rounded-md hover:bg-red-700 text-sm my-3 lg:mx-2' type="button">
										Agregar o Modificar
									</button>
								</Popconfirm>
								<button className='bg-buttons text-white p-1.5 rounded-md hover:bg-red-700 text-sm my-3 lg:mx-2' type="button" onClick={() => setIsEditTreatment(false)}>
									Cancelar
								</button>
							</>
						:
						<>
							<button className='bg-buttons text-white p-1.5 rounded-md hover:bg-red-700 text-sm my-3 lg:mx-2' type="button" onClick={goToEditTreatment}>
								Agregar o Modificar tratamiento de Paciente
							</button>
							<button className='bg-buttons text-white p-1.5 rounded-md hover:bg-red-700 text-sm my-3 lg:mx-2' type="button" onClick={goToPrintHom}>
								Imprimir Homeopatico
							</button>
							<button className='bg-buttons text-white p-1.5 rounded-md hover:bg-red-700 text-sm my-3 lg:mx-2' type="button" onClick={goToPrintFloral}>
								Imprimir Esencia Floral
							</button>
							<button className='bg-buttons text-white p-1.5 rounded-md hover:bg-red-700 text-sm my-3 lg:mx-2' type="button" onClick={goToPrintCert}>
								Imprimir Certificado
							</button>
							<button className='bg-buttons text-white p-1.5 rounded-md hover:bg-red-700 text-sm my-3 lg:mx-2' type="button" onClick={printDiv}>
								Imprimir Historia
							</button>
						</>}
					</div>
					<hr />
					<div className='my-5 ocultarPrintDiv'>
						<div className="image-upload-container">
							<UploadImageWithPreview evolutionId={evolutionSelect._id}/>
						</div>
					</div>
				</div>}
			</div>
		</div>
	)
}

export default Evolution